import { render, staticRenderFns } from "./LotsTable.vue?vue&type=template&id=095c34bc&scoped=true"
import script from "./LotsTable.vue?vue&type=script&lang=js"
export * from "./LotsTable.vue?vue&type=script&lang=js"
import style0 from "./LotsTable.vue?vue&type=style&index=0&id=095c34bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095c34bc",
  null
  
)

export default component.exports